import { Breadcrumb, TitleScreen } from "components/Core"
import FormRoute from "components/Custom/FormRoute"
import { useParams } from "react-router-dom"

const EditScreen = () => {
  const { route_id } = useParams()

  return (
    <div className="w-full h-full flex flex-col items-start justify-start pb-10">
      <Breadcrumb
        data={[
          { name: "Listado de rutas", href: "/routes" },
          { name: "Edición de ruta", href: `/routes/${route_id}/edit` },
        ]}
      />
      <div className="w-full flex flex-col justify-center items-center pt-4 px-6">
        <TitleScreen title="Edición de ruta" string_id={route_id} />
      </div>
      <div className="w-full flex flex-col py-2 px-4">
        <FormRoute routeId={route_id} />
      </div>
    </div>
  )
}

export default EditScreen
